import { DISPLAY_DECIMALS, formatMoneyExact } from '../lib/format';

// PRD: default benchmark ROAS 2.0x (ops-configurable per vertical; V1 constant).
export const BENCHMARK_ROAS = 2.0;

const intFmt = new Intl.NumberFormat('en-IN');

/** Axis ticks stay whole: a two-decimal tick on every gridline is unreadable.
 *  The AppsFlyer report carries no currency field, so amounts here are rupees. */
const axisMoneyFmt = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  maximumFractionDigits: 0,
});

export const fmtInt = (n: number): string => intFmt.format(Math.round(n ?? 0));
export const fmtMoney = (n: number): string => formatMoneyExact(n ?? 0);
export const fmtAxisMoney = (n: number): string => axisMoneyFmt.format(n ?? 0);
export const fmtRoas = (r: number | null): string =>
  r == null ? 'N/A' : `${r.toFixed(DISPLAY_DECIMALS)}x`;
export const rate = (num: number, den: number): number | null => (den > 0 ? num / den : null);
export const fmtPct = (r: number | null): string =>
  r == null ? '-' : `${(r * 100).toFixed(DISPLAY_DECIMALS)}%`;

/** ROAS tile subtext: the gap to the benchmark, or the formula when ROAS is
 *  unknown. Rounds once, at the point of display. */
export function roasBenchmarkSubtext(roas: number | null | undefined): string {
  if (roas == null) return 'Revenue ÷ creator fee';
  const deltaPct = ((roas - BENCHMARK_ROAS) / BENCHMARK_ROAS) * 100;
  const arrow = deltaPct >= 0 ? '▲' : '▼';
  return `${arrow} ${Math.abs(deltaPct).toFixed(DISPLAY_DECIMALS)}% vs ${BENCHMARK_ROAS.toFixed(DISPLAY_DECIMALS)}x benchmark`;
}
